import { motion } from 'framer-motion'
import { formatTime } from '../../lib/utils'
import { BoatIndicator } from '../ui/BoatIndicator'

interface BestLapOverlayProps {
  pilotName: string
  boatNumber: number
  boatColor: string
  lapTime: number
}

export function BestLapOverlay({
  pilotName,
  boatNumber,
  boatColor,
  lapTime,
}: BestLapOverlayProps) {
  return (
    <div className="min-h-screen bg-transparent flex items-center justify-start p-4">
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        className="bg-gradient-to-r from-tropical-green to-paradise-blue p-1 rounded-xl"
      >
        <div className="bg-palm-dark rounded-lg px-8 py-6 backdrop-blur-sm">
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 2, repeat: Infinity }}
            className="text-6xl mb-4"
          >
            🏁
          </motion.div>

          <div className="font-fredoka font-700 text-4xl text-transparent bg-clip-text bg-gradient-to-r from-tropical-green to-paradise-blue mb-2">
            BEST LAP
          </div>

          <div className="flex items-center gap-4 mt-6">
            <div>
              <div className="text-sm uppercase text-gray-400 font-quicksand mb-1">
                Time
              </div>
              <div className="text-3xl font-fredoka font-700 text-tropical-green">
                {formatTime(lapTime)}
              </div>
            </div>

            <div className="w-px h-12 bg-tropical-green bg-opacity-30" />

            <div>
              <div className="text-sm uppercase text-gray-400 font-quicksand mb-1">
                Pilot
              </div>
              <div className="text-xl font-fredoka font-700 text-sand-light">
                {pilotName}
              </div>
            </div>

            <BoatIndicator
              boatNumber={boatNumber}
              color={boatColor}
              size="md"
            />
          </div>
        </div>
      </motion.div>
    </div>
  )
}
